import { render, staticRenderFns } from "./bjEdit_v1.vue?vue&type=template&id=fd416e48&scoped=true&"
import script from "./bjEdit_v1.vue?vue&type=script&lang=js&"
export * from "./bjEdit_v1.vue?vue&type=script&lang=js&"
import style0 from "./bjEdit_v1.vue?vue&type=style&index=0&id=fd416e48&lang=less&scoped=true&"
import style1 from "./bjEdit_v1.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd416e48",
  null
  
)

component.options.__file = "bjEdit_v1.vue"
export default component.exports